
        var result = require("!!../../../node_modules/css-loader/index.js!./custom-modals.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-modals/custom-modals.component.css
// module id = 721
// module chunks = 0